import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getUserEvent } from "../../services/UserServices/UserService";
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { User } from "lucide-react";
import PageTitle from "../layouts/PageTitle";

 

const UserEvents = () => {
      const { id } = useParams();
     const [userEvent, setUserEvent] = useState([]);
     const navigate=useNavigate()
const location = useLocation();
  const historyData = location.state?.history;


   
      useEffect(() => {
        const getEvent = async () => {
          try {
            const res = await getUserEvent(id);
             const sortedEvents = res?.data?.data?.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      setUserEvent(sortedEvents);
            
          } catch (error) {
            console.error(error?.response?.data?.message);
          }
        };
        if (id) {
          getEvent();
        }
      }, []);



    
  return (
    <div className="user-details-page container ">
     <PageTitle
          motherMenu="User List"
          activeMenu={` ${historyData?.user?.hostName}  > Events`}
          pathBack={true}   
        />
{userEvent && userEvent.length>0 && (<>  <h2
        className=" mb-4 user-detail-title font-fm"
        style={{ fontSize: "50px" }}
      >
    
     
      </h2>
      <Card className="shadow-lg event-card mb-5 roun" >
        <Card.Body >
          {userEvent.map((event) => (
            <div
              key={event._id}
              className="event-item mb-4 p-3 rounded d-flex justify-content-between align-items-center"
            >
              {/* Left side - Event details */}
              <div>
                <h5 className="fw-bold mb-3">{event?.name.name}</h5>

                <div className="d-flex justify-content-between mb-1">
                  <strong className="label-text me-5">Date:</strong>
                  <span>
                    {" "}
                    {new Date(event?.eventDate).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}
                  </span>
                </div>

               

                <div className="d-flex justify-content-between mb-1">
                  <strong className="label-text me-5">Venue:</strong>
                  <span>{event?.eventVenue?event?.eventVenue:"NAN"}</span>
                </div>

                <div className="d-flex justify-content-between mb-1">
                  <strong className="label-text">Theme:</strong>
                  <span>{event?.theme?.name?event?.theme?.name:"NAN"}</span>
                </div>

                <div className="d-flex justify-content-between mb-1">
                  <strong className="label-text">Dress Code:</strong>
                  <span>{event?.dressCode?.name ? event?.dressCode?.name : "NAN"}</span>
                </div>

                <div className="d-flex justify-content-between mb-1">
                  <strong className="label-text">Dress Color:</strong>
                  <span>{event?.dressColor?.name?event?.dressColor?.name:"NAN"}</span>
                </div>
              </div>

              {/* Right side - Buttons */}
              <div className="ms-3">
             
               <Button
                              className="me-2 maroon-btn"
                              onClick={() => navigate(`/guests/${id}/${event._id}`,{
                  state: { history: {event} } 
                })}
                            >
                            Guests
                            </Button>

                 {event.subEvents && event.subEvents.length>0 && (<>  
              <Button
                               className="me-2 maroon-btn"
                               onClick={() => navigate(`/sub-events/${id}/${event._id}`,{
                   state: { history: {event} } 
                 })}
                             >
                               Sub Events
                             </Button></>)}
               <Button
                                 className="me-2 maroon-btn"
                                 onClick={() => navigate(`/tasks/${id}/${event._id}`,{
                     state: { history: {event} } 
                   } )}
                               >
                                 Tasks
                               </Button>
                                
                
              </div>
            </div>
          ))}
 
        </Card.Body>

      </Card> 
    </>)}

    </div>
  )
}

export default UserEvents
